// extracted by mini-css-extract-plugin
export default {"register":"register_wY2Yr","container":"container_lJEmb","left":"left_tE3du","right":"right_JrEfV"};